export const phrases = {
  unassign_from_album: "Ønsker du virkelig å fjerne de valgte bildene fra albumet?",
  remove_media_from_album: "Fjern fra albumet",
  assign_to_which_album: "Hvilket album ønsker du å legge til de valgte bildene i?",
  rename_album_title: "Du kan redigere albumet ditt her",
  name_of_album: "Hva kommer det nye albumet ditt til å hete?",
  create_album: "Nytt album",
  assign_media_to_album: "Legg til i et album",
  your_party: "Festen din.",
  all_pictures: "Alle bildene.",
  forgot_password: "Har du glemt passordet ditt?",
  no_account_yet: "Har du ikke en konto ennå? Registrer deg nå.",
  send_your_event: "Inviter gjestene dine",
  scan_here: "Skann her",
  show_more_replies: "se flere svar",
  shared_image_text: "Ta en titt på bildet som er tatt på et arrangement med https://www.everlense.de",
  image_not_available_anymore: "Dette bildet er ikke lenger tilgjengelig",
  invite_whatsapp: "Jeg gleder meg veldig til det kommende arrangementet 🥳. For å gjøre vår tid sammen uforglemmelig med flotte bilder, inviterer jeg deg til å bruke everlense. Bare klikk på lenken og skriv navnet ditt på gjestelisten. Ta flotte bilder og del dem med de andre gjestene. Vi sees snart! ",
  add_images: "Legg til bilder",
  capture_photo: "Ta et bilde",
  enter_your_name: "Skriv inn navnet ditt",
  your_photo_app_for_weddings: "Din fotoapp for bryllup",
  invite_guests: "Inviter gjester",
  delete_demo_data: "Slett demodata",
  event_description_placeholder: "Hva mer vil du fortelle gjestene dine? Gå til innstillingene for å tilpasse beskrivelsen.",
  start_slideshow: "Start lysbildeserien her",
  slideshow_steps_1: "Gå til med enheten din",
  slideshow_steps_2: "og skriv inn følgende",
  slideshow_steps_3: "10-sifret kode",
  slideshow_steps_4: "i.",
  print_tasks: "Skriv ut oppgaver",
  edit_tasks: "Administrer oppgaver",
  challenge_tips_and_tricks_1: "Tips og triks for",
  challenge_tips_and_tricks_2: "Din perfekte utfordring",
  challenge_tips_and_tricks_content_1: "Skriv ut malen på tykt papir.",
  challenge_tips_and_tricks_content_2: "Fordel oppgavene til hver plass før festen.",
  challenge_tips_and_tricks_content_3: "Fortell så mange som mulig om fotoutfordringen.",
  challenge_tips_and_tricks_content_4: "Bruk live-lysbildefremvisning slik at alle gjestene kan se øyeblikksbildene i sanntid.",
  print_tasks_intro: "Du bør henge dem opp på festen, slik at gjestene dine kan finne fotoutfordringsoppgavene.",
  print_tasks_title_1: "Kort til å skrive ut (populært)",
  print_tasks_title_2: "Eksporter kun QR-koder (og design kortene selv)",
  print_tasks_action_1: "Last ned PDF-filer",
  print_tasks_action_2: "Last ned QR-koder",
  print_tasks_description_1: "Gjestene dine kan delta i fotoutfordringen ved å bruke QR-kodene på kortene som kan skrives ut.",
  print_tasks_description_2: "Last ned QR-koder for å starte fotoutfordringen, og bruk dem til å designe dine egne kort. Det er én QR-kode per oppgave.",
  edit_tasks_title_1: "Velg oppgaver",
  edit_tasks_title_2: "for gjestene dine",
  really_want_to_delete_task: "Virkelig slette oppgaven?",
  add_task_button: "Legg til oppgave",
  delete_all_tasks_button: "Slett alle",
  settings_albums: "Albuminnstillinger",
  upload_to_which_album: "Hvilket album skal gjestenes bilder automatisk lastes opp til?",
  upload_which_albums_are_shown: "Hvilke album vil du at gjestene dine skal se?",
  restrict_access_to_album: "Gjestene mine har bare tilgang til det valgte albumet",
  settings_event_name_header: "Hva skal arrangementet ditt hete?",
  settings_event_description_header: "Hva mer trenger gjestene dine å vite?",
  settings_event_name_label: "Navn på arrangementet",
  settings_event_description_label: "Beskrivelse av arrangementet",
  settings_password_title: "Endre passord",
  settings_old_password_header: "Gammelt passord",
  settings_new_password_header: "Nytt passord",
  settings_new_password_repeat_header: "Gjenta nytt passord",
  settings_invite_admin_title: "Legg til administratorer",
  settings_invite_admin_header: "E-postadressen til den nye administratoren",
  send_invite: "Send invitasjon",
  settings_deactivate_challenge_title: "Deaktiver utfordring",
  settings_deactivate_challenge_header: "Aktiver/deaktiver utfordringen",
  settings_delete_data_title: "Slett konto",
  settings_delete_data_header: "Slett alle data permanent",
  delete_event: "Slett hendelse",
  delete_event_toast_content: "Klikk på \"Slett\" for å stenge kontoen din permanent. OBS: Alle opplastede bilder, videoer og data er da ugjenkallelig tapt og kan ikke lenger gjenopprettes, selv ikke av everlense-teamet.",
  settings_legal: "Juridiske forhold",
  settings_legal_content_1: "Når du oppretter arrangementet ditt, har du",
  settings_legal_content_2: "GTC",
  settings_legal_content_3: " og vår",
  settings_legal_content_4: "Retningslinjer for personvern ",
  settings_legal_content_5: "akseptert. Hvis du ønsker å finne ut mer om everlense, kan du besøke vår ",
  settings_legal_content_6: "Trykk.",
  reset_password: "Tilbakestill passord",
  register_phrase: "Vi trenger e-postadressen din for å fullføre oppsettet av arrangementet ditt.",
  register_phrase_booked: "Bestillingen var vellykket! Vi trenger e-postadressen din for å fullføre oppsettet av arrangementet ditt.",
  email_address: "E-postadresse",
  register_legal: "Ved å bli medlem aksepterer du våre <a class=\"underline\" href=\"https://www.everlense.de/agb\">vilkår og betingelser</a> og vår <a class=\"underline\" href=\"https://www.everlense.de/datenschutz\">personvernerklæring</a>. Hvis du vil vite mer om everlense, kan du gå til vår <a class=\"underline\" href=\"https://www.everlense.de/impressum\">juridiske merknad</a>. Ved å registrere deg godtar du også å motta markedsføring via e-post fra oss. Du kan når som helst trekke tilbake dette samtykket.",
  guest_register_legal: "Ved å bli medlem aksepterer du våre <a class=\"underline\" href=\"https://www.everlense.de/agb\">vilkår og betingelser</a> og vår <a class=\"underline\" href=\"https://www.everlense.de/datenschutz\">personvernerklæring</a>. Hvis du vil vite mer om everlense, kan du gå til vår <a class=\"underline\" href=\"https://www.everlense.de/impressum\">juridiske merknad</a>.",
  install_everlense: "Installer everlense",
  install_content_1: "Installer everlense på startskjermen for å aldri glemme begivenheten.",
  install_content_2: "Klikk",
  install_content_3: "og deretter \"Gå til startskjermen\".",
  install_content_4: "Senere",
  install_content_5: "Greit!",
  no_images_yet: "Ingen bilder er lastet opp ennå. Trykk på plussknappen for å laste opp et bilde.",
  delete_all_tasks_really: "Virkelig slette alle oppgaver?",
  your_task: "Din oppgave",
  change_colors: "Endre farger",
  primary_color: "Primærfarge",
  background_color: "Bakgrunnsfarge",
  reset: "Tilbakestill",
  choose_color: "Velg farge",
  upgrade_package: "Oppgraderingspakke",
  upgrade_required: "Oppgradering nødvendig",
  current_package: "Nåværende pakke",
  used_image_count: "{used} av {max} bilder.",
  deleted_image_count: "{not_deleted} for øyeblikket i galleriet ditt, {deleted} slettet.",
  used_downloads_count: "{used} brukes av {max} massedownloads.",
  most_popular: "Mest populære",
  price: '{price} Euro',
  max_media: "maks. {count} bilder",
  max_guests: "maks. {count} Gjester",
  infinite_guests: "Ubegrenset antall gjester",
  storage_duration: "{duration} Måneder Lagringsperiode",
  max_bulk_downloads: "gratis nedlasting i bulk | gratis nedlasting i bulk",
  custom_colors: "Individuelle farger",
  multiple_admins: "Flere administratorer",
  whatsapp_support: "Premium WhatsApp-støtte",
  go_to_checkout: "Til kassen",
  start_setup: "Start oppsett",
  upgrade_toast_content: "For å kunne bruke denne funksjonen må du oppgradere everlense-pakken. Ta en titt på de ulike alternativene. ",
  no_thank_you: "Nei, takk skal du ha.",
  i_want_to_know_more: "Lær mer",
  demo_event_title: "Lisa og Jan",
  how_do_you_want_to_reedem: "Hvordan ønsker du å løse inn pakken din?",
  currently_logged_in_event: "Du er for øyeblikket logget inn på arrangementet: {name} Ønsker du å bruke kjøpet ditt på dette arrangementet?",
  choose_event: "Hvilket arrangement ønsker du å bruke kjøpet ditt på?",
  use_for_current_event: "aktuell hendelse",
  use_for_existing_event: "eksisterende arrangement",
  use_for_new_event: "nytt arrangement",
  settings_event_date_header: "Når finner arrangementet ditt sted?",
  settings_event_date_label: "Dato for arrangementet",
  sort: "Sortere",
  time_of_recording: "Opptakstid",
  time_of_upload: "Tid for opplasting",
  lets_setup_event: "La oss organisere arrangementet ditt sammen",
  we_will_help_you_setup: "Vi hjelper deg med å sette opp everlense-arrangementet ditt på bare 2 minutter. Har du lyst på det?",
  what_is_the_name: "Hva skal arrangementet ditt hete?",
  cancel_setup: "Avbryt oppsett",
  enter_event_name_here: "Skriv inn arrangementets navn her",
  when_does_event_take_place: "Når finner arrangementet ditt sted?",
  enter_event_date_here: "Skriv inn dato for arrangementet her",
  nice_please_upload_photo: "Veldig hyggelig. Last opp et bilde av begivenheten nå for å gjøre den enda mer personlig",
  select_photo: "Velg bilde",
  what_do_you_want_to_describe: "Jøss! Er det noe annet du vil fortelle gjestene dine?",
  enter_description_here: "Skriv inn beskrivelse her",
  finish_setup: "Fullfør oppsettet",
  successfull_save: "Vellykket lagret",
  successfull_deletion: "Vellykket slettet",
  copied_link: "Kopiert lenke",
  booking_successfull: "Booking vellykket",
  completed_setup: "Installasjonen er fullført",
  sent_invite: "Invitasjon sendt",
  initiated_payout: "Utbetaling opprettet",
  sent_email: "E-post sendt",
  max_ten_images: "Maksimalt 10 bilder samtidig.",
  reached_download_limit: "Nedlastingsgrensen for arrangementet er nådd.",
  reached_mass_download_limit: "Maksimalt antall massenedlastinger er nådd.",
  no_images_were_uploaded: "Ingen bilder er lastet opp ennå.",
  booking_failed: "Bestillingen mislyktes.",
  package_already_retrieved: "Pakken er allerede innløst",
  download_all_pictures: "Last ned alle bilder",
  notice: "Hint",
  in_your_package: "I pakken din",
  bulk_download_modal_2: "av alle bildene på en gang. Hvis du nå klikker på \"Last ned\", vil du konsumere",
  bulk_download_modal_3: "en av disse",
  bulk_download_modal_4: "dette",
  bulk_download_modal_5: "nedlasting",
  bulk_download_modal_6: "Du har brukt opp alle bulknedlastningene i pakken din. Bestill en oppgradering for å laste ned alle bildene.",
  bulk_download_modal_7: "Vennligst vent litt. Bildene dine klargjøres for nedlasting.",
  donwload_modal_1: '',
  donwload_modal_2: "virkelig laste ned?",
  delete_modal_1: '',
  delete_modal_2: "virkelig slette?",
  download_preparation: "Nedlastingen din er under forberedelse. Du vil motta en e-post med din personlige nedlastingslenke senest om 15 minutter.",
  save_pictures: "Lagre bilder",
  delete_pictures: "Slett bilder",
  upload_in_progress: "Last opp løpende",
  change_language: "Endre språk",
  change_language_info: "Vi har utviklet everlense slik at språket automatisk tilpasser seg språket i nettleseren på gjestenes enheter. Så hvis du har internasjonale gjester i bryllupet ditt, er dette ikke noe problem, og bildegalleriet er alltid forståelig for alle.",
  multiple_languages_1: "Flerspråklighet",
  multiple_languages_2: "(engelsk og tysk)",
  okay: "Greit!",
  download_pictures: "Last ned bilder",
  max_ten_images_go_to_settings: "Maksimalt 10 bilder er tillatt. Gå til innstillingene for å laste ned alle bildene.",
  your_images_are_ready: "Jippi, bildene dine er klare!",
  here_are_your_images: "Her er bildene av arrangementet ditt {event}. Ha det gøy!",
  ps_mass_download: "PS: Bare last ned delene én etter én. Dette vil bare bli regnet som en bulknedlasting.",
  download_here: "Last ned her",
  download_part: "Last ned del {part}",
  switch_language: "Endre språk",
  tasks_choose_language: "Hvilket språk bør eksempeloppgavene ha?",
  successfull_task_recreation: "Språket i eksempeloppgavene har blitt endret",
  something_went_wrong: "Noe har gått galt",
  a_small_present_for_you: "En liten gave til deg!",
  present_description: "Ønsker du å bruke everlense på ditt arrangement? <span class=\"font-medium\">Da har vi en overraskelse til deg.</span> Vi sender den til din e-postadresse.",
  your_email_address: "E-postadressen din",
  save_discount: "Sende",
  accept_agb_and_mail: "Jeg godtar <a href=\"https://www.everlense.de/agb\" class=\"font-medium cursor-pointer\">vilkårene og betingelsene</a> og ønsker å motta e-post fra everlense.",
  thank_you_for_sending: "Vi sender deg en e-post med din personlige overraskelse i løpet av de neste 15 minuttene.",
  discount_saved: "Overraskelse sikret!",
  was_reported: "En gjest har rapportert dette {type} .",
  what_shall_happen: "Hva skal skje med denne {type} ?",
  edit_reporting_description: "Vennligst sjekk {type} og avgjør om det skal legges ut igjen eller slettes permanent. Vi har skjult bildet i mellomtiden.",
  how_did_you_get_to_know_us: "Hvordan fikk du høre om Everlense?",
  please_select: "Vennligst velg",
  friends_and_family: "Venner og bekjente",
  seen_at_a_wedding: "Sett i et bryllup",
  other: "Diverse",
  settings_deactive_challenge_text_download: "Merking av bilder under nedlasting",
  your_payment_is_processing: "Betalingen din er under behandling. Vennligst vær tålmodig et øyeblikk.",
  coupon_code: "Kupongkode",
  what_discount_code: "Hva skal den personlige rabattkoden din hete?",
  message_to_everlense_team: "Melding til everlense-teamet",
  select_design: "Velg design",
  choose_your_flyer_design: "Velg design på QR-kodekortet ditt:",
  choose_your_qr_design: "Velg farge på QR-koden:",
  show_qr_code_on_diashow: "Vis QR-kode på live lysbildefremvisning",
  diashow_prioritize_new: "Prioriter visning av nye bilder",
  more_settings: "Ytterligere innstillinger",
  duration_per_medium: "Visningstid per bilde",
  album_not_visible_to_guests: "Albumet må være synlig."
};